// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table {\n  border: 1px solid #e6e4eb;\n  border-radius: 6px;\n}\n.custom_table_class thead th {\n  border-radius: 6px 6px 0 0;\n}\ntable.v-table tbody td {\n  height: 40px;\n  border: none;\n}\n.theme--light.v-table tbody tr:not(:last-child) {\n  border-bottom: none;\n}", ""]);
// Exports
module.exports = exports;
